import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import APIcon from 'apex-web/lib/components/common/APIcon';
import Link from '../../components/common/Link';
import config from '../../config';

const linkOpenInNew = item => {
  let w = config.Footer.openInNewWindowGlobal;
  if ('openInNewWindow' in item) w = item.openInNewWindow;
  return w;
};

const PageHeaderNavGroup = ({ item, customClass, t, handleNavItemClick, sidebar }) => {
  const [open, setOpen] = useState(false);
  const IconComponent = item.Icon;
  return (
    <div
      className={customClass('group', {
        open: open,
        sidebar: !!sidebar
      })}>
      <button
        type="button"
        className={customClass('item', ['hoverable', 'group-toggle'])}
        aria-expanded={open}
        onClick={() => setOpen(v => !v)}
        title={t(item.text)}>
        {IconComponent ? (
          <IconComponent
            className={customClass('icon', ['react'])}
            aria-hidden="true"
            focusable="false"
          />
        ) : (
          <APIcon name={item.icon} customClass={customClass('icon')} />
        )}
        <span className={customClass('label')}>{t(item.text)}</span>
        <span
          className={customClass('group-caret', { open: open })}
        >
          <APIcon name="dropdown" customClass={customClass('icon')} />
        </span>
      </button>
      {open && (
        <div
          className={customClass('submenu', { sidebar: !!sidebar })}
          role="region"
          aria-label={t(item.text)}
        >
          <div className={customClass('sublist')}>
            <span
              className={customClass('sublist-rail')}
              aria-hidden="true"
            />
            <div className={customClass('sublist-items')}>
              {item.children.map((child, innerIdx) => {
                const o = linkOpenInNew(child);
                return (
                  <Link
                    key={`${item.key || item.text}-${innerIdx}`}
                    className={customClass('sublink')}
                    href={child.link}
                    target={o ? '_blank' : undefined}
                    rel={o ? 'noopener noreferrer' : undefined}
                    onClick={handleNavItemClick}
                    title={t(child.text)}
                  >
                    {t(child.text)}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const PageHeaderNavMenuComponent = (props, context) => {
  const { customClass, handleNavItemClick, navItems, sidebar } = props;
  const t = context.t;

  return navItems.map(item => {
    if (item.children && item.children.length) {
      return (
        <PageHeaderNavGroup
          key={item.key || item.path || `group-${item.text}`}
          item={item}
          customClass={customClass}
          t={t}
          handleNavItemClick={handleNavItemClick}
          sidebar={sidebar}
        />
      );
    }

    const IconComponent = item.Icon;
    return (
      <NavLink
        key={item.path}
        to={item.path}
        title={t(item.text)}
        onClick={handleNavItemClick}
        className={customClass('item', ['hoverable'])}
        activeClassName={customClass('item', ['selected'])}>
        {IconComponent ? (
          <IconComponent
            className={customClass('icon', ['react'])}
            aria-hidden="true"
            focusable="false"
          />
        ) : (
          <APIcon name={item.icon} customClass={customClass('icon')} />
        )}
        <span className={customClass('label')}>{t(item.text)}</span>
      </NavLink>
    );
  });
};

PageHeaderNavGroup.propTypes = {
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
    .isRequired,
  item: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  handleNavItemClick: PropTypes.func,
  sidebar: PropTypes.bool
};

PageHeaderNavMenuComponent.propTypes = {
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  handleNavItemClick: PropTypes.func,
  sidebar: PropTypes.bool,
  navItems: PropTypes.arrayOf(PropTypes.object)
};

PageHeaderNavMenuComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default PageHeaderNavMenuComponent;
